import { Chip, styled } from '@mui/material';

const showEnvironmentFlag =
  !!process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE !== 'production';

const environmentFlagColor =
  process.env.REACT_APP_STAGE === 'uat'
    ? 'primary'
    : process.env.REACT_APP_STAGE === 'local'
    ? 'secondary'
    : 'default';

const EnvironmentFlagChip = styled(Chip)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));

const EnvironmentFlag: React.FC = () =>
  showEnvironmentFlag ? (
    <EnvironmentFlagChip
      label={process.env.REACT_APP_STAGE?.toUpperCase()}
      color={environmentFlagColor}
      size="small"
    />
  ) : null;

export default EnvironmentFlag;
